import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import { ElMessage, ElMessageBox, ElNotification } from 'element-plus';
import { sizeFilter, handleHttp, transformStr3, getformListItemsdatas, formatToLine, insertStr } from "@/utils/utils";
import 'ol/ol.css';
import { Map, View } from 'ol';
import TileLayer from 'ol/layer/Tile';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import SourceImagestatic from 'ol/source/ImageStatic';
import LayerImage from 'ol/layer/Image';
import XYZ from 'ol/source/XYZ';
import { defaults } from 'ol/control';
import Attribution from 'ol/control/Attribution';
import { transformExtent, fromLonLat, transform } from 'ol/proj';
import Projection from 'ol/proj/Projection';
import Point from 'ol/geom/Point';
import Style from 'ol/style/Style';
import StyleIcon from 'ol/style/Icon';
import StyleText from 'ol/style/Text';
import StyleFill from 'ol/style/Fill';
import StyleStroke from 'ol/style/Stroke';
import { Circle } from 'ol/style';
import Feature from 'ol/Feature';
import DragPan from 'ol/interaction/DragPan';
import MouseWheelZoom from 'ol/interaction/MouseWheelZoom';
import DoubleClickZoom from 'ol/interaction/DoubleClickZoom';
import Draw from 'ol/interaction/Draw';
import Select from 'ol/interaction/Select';
import Format from 'ol/format';
import { GeoJSON } from 'ol/format';
import Modify from 'ol/interaction/Modify';
import Collection from 'ol/Collection';
import pointdata from '@/view/map/hdmconfig/pointdata';
import mapdata from '@/view/map/hdmconfig/mapdata';
import maptype from '@/view/map/hdmconfig/type';
import { getPan, getPinchRotate } from '@/view/map/js/common';
export default {
  name: 'mapconfig',
  components: {
    pointdata,
    mapdata,
    maptype
  },
  meta: {
    title: '地图配置页'
  },
  data() {
    return {
      fid: this.$route.query.fid,
      isAddOrEdit: true,
      form: {},
      maxleveloptions: [],
      minleveloptions: [],
      leveloptions: [],
      dataleveloption: [],
      defalutImages: {},
      currentformuser: {},
      formrules: {
        title: [{
          required: true,
          message: '请填写地图名称'
        }],
        toptitle: [{
          required: true,
          message: '请填写头部标题'
        }]
      },
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      file: {},
      fileArr: [{
        name: 'logo',
        data: ''
      }, {
        name: 'pickey',
        data: ''
      }, {
        name: 'background_img',
        data: ''
      }, {
        name: 'static_img',
        data: ''
      }, {
        name: '4',
        data: ''
      }, {
        name: 'audio',
        data: ''
      }, {
        name: 'banner',
        data: []
      }, {
        name: 'video',
        data: ''
      }],
      currentfileName: '',
      stepIndex: 0,
      mapconfigstruct: [],
      mpcdata: {},
      mpcAlldata: '',
      iconLayer: '',
      iconSource: '',
      imageLayer: '',
      map: null,
      mapconfig: {
        mapMinZoom: 1,
        mapMaxZoom: 2,
        center: [],
        extent: [],
        currentZoom: 1
      },
      typeArr: [],
      typeFlag: false,
      typeList: [],
      currentType: 0,
      typestruct: [],
      detailflag: false,
      dataList: [],
      datastruct: [],
      dataform: {},
      detailImages: {},
      dataformlabel: {},
      dataformoption: {},
      isAddDataflag: true,
      currentLiIndex: '',
      detailObj: {},
      // 地点文字样式配置
      mtObj: {
        title_font: 'bold 14px 微软雅黑',
        title_color: 'rgba(255,255,255,1)',
        title_bgcolor: 'rgba(0, 0, 255, 0.7)',
        title_bocolor: '',
        offsetX: 0,
        offsetY: 32,
        padding: [2, 10, 1, 10]
      },
      jsonOption: {},
      elemName: '',
      toolbarflag: false,
      elemCss: {},
      compt: {
        // 绝对定位快捷选项
        absoluteArrindex: 0,
        absoluteArr: [{
          icon: 'icon-lt',
          text: '左上角'
        }, {
          icon: 'icon-rt',
          text: '右上角'
        }, {
          icon: 'icon-lb',
          text: '左下角'
        }, {
          icon: 'icon-rb',
          text: '右下角'
        }],
        heightflag: false
      },
      styleform: {},
      styleOption: {},
      styleDialog: false,
      changePosition: false,
      bdmap: {},
      BDmap: null,
      zoom: 0,
      showRightslide: true,
      screenIndex: 0,
      isPc: true,
      typemodel: 1,
      maininnerStyle: '',
      screenvalue: 100,
      // 主题分辨率
      leftUlIndex: '',
      activeName: '默认',
      typeUlIndex: 0,
      otherform: {},
      draw: '',
      drawsource: '',
      drawLayer: '',
      collection: '',
      modify: '',
      drawstyle: [],
      typeshow: true,
      linefoucs: false,
      lineform: {
        size: 1,
        style: '',
        color: ''
      },
      mapdataform: {
        formId: '165054',
        page: 1,
        limit: 100,
        searchStr: ''
      },
      // 搜索定位点字段
      searchStr: {
        model: 0,
        filters: [{
          "model": 0,
          "filters": [{
            'alias': '40',
            'compt': 'editinput',
            'express': '===',
            'val': ''
          }]
        }, {
          "model": 1,
          "filters": []
        }]
      },
      defaultIcon: require('../../../assets/map/icon_address_red.png')
    };
  },
  mounted() {
    document.querySelector('html').style.height = '100%';
    document.querySelector('body').style.height = '100%';
    document.querySelector('#app').style.height = '100%';
    // 自动登录获取token
    this.login();
    this.getTypeStruct();
  },
  watch: {},
  methods: {
    // 移除操作
    hoverOutHandle(event) {
      event.preventDefault();
      this.elemName = '';
      this.toolbarflag = false;
    },
    // 选中 添加/编辑样式
    styleHandle(name) {
      this.elemName = name;
      this.styleDialog = true;
      // console.log(this.elemName)
      let csO = ['offsetHeight', 'offsetWidth', 'offsetLeft', 'offsetTop'];
      let csV = {};
      csO.forEach(item => {
        this.elemCss[item] = document.querySelector(`.${this.elemName}`)[item];
        csV[item] = document.querySelector(`.${this.elemName}`)[item];
      });
      this.styleform.width = csV.offsetWidth;
      this.styleform.left = csV.offsetLeft;
      this.styleform.top = csV.offsetTop;
      this.otherform.backgroundfile = [];
      console.log(this.mpcAlldata);
      console.log(this.mpcAlldata.jsonOption);
      // console.log(this.elemName)
      // console.log(this.styleform)
      // console.log(this.otherform.backgroundImage)
    },
    // 样式改变触发事件
    csshandleChange(val) {
      let style = JSON.parse(JSON.stringify(this.styleform));
      Object.keys(style).forEach(elem => {
        if (typeof style[elem] === 'object') return;
        console.log(style[elem], Object.prototype.toString(style[elem]));
        style[elem] === 0 || style[elem] === undefined ? style[elem] = 'auto' : style[elem] += 'px';
      });
      this.jsonOption[this.elemName] = style;
    },
    // 默认/选中改变触发事件
    othercsshandleChange(val) {
      // console.log(val)
      // console.log(this.otherform[val])
      if (this.typeUlIndex === 0) {
        this.styleform.othernormalform = JSON.parse(JSON.stringify(this.otherform));
      }
      if (this.typeUlIndex === 1) {
        this.styleform.otherfocusform = JSON.parse(JSON.stringify(this.otherform));
      }
      let style = JSON.parse(JSON.stringify(this.styleform));
      Object.keys(style).forEach(elem => {
        if (typeof style[elem] === 'object') return;
        style[elem] === 0 || style[elem] === undefined ? style[elem] = 'auto' : style[elem] !== '' ? style[elem] += 'px' : '';
      });
      this.jsonOption[this.elemName] = style;
      // console.log(this.jsonOption[this.elemName])
    },
    absolutechange(index) {
      this.compt.absoluteArrindex = index;
      this.changePosition = true;
      let positionstyle = this.selectabsolute();
      let style = {};
      Object.keys(positionstyle).forEach(elem => {
        positionstyle[elem] === 0 ? style[elem] = 'auto' : style[elem] = positionstyle[elem] + 'px';
      });
      let csO = ['top', 'right', 'bottom', 'left'];
      csO.forEach(elem => {
        this.styleform[elem] = positionstyle[elem];
      });
      this.jsonOption[this.elemName] = style;
      this.changePosition = false;
    },
    selectabsolute() {
      let cp = this.changePosition;
      let pindex = this.compt.absoluteArrindex;
      let style = JSON.parse(JSON.stringify(this.styleform));
      let csO = ['top', 'right', 'bottom', 'left'];
      if (cp) csO.forEach(elem => {
        style[elem] = 60;
      });
      if (cp && pindex === 0) {
        style.right = 0;
        style.bottom = 0;
      }
      if (cp && pindex === 1) {
        style.left = 0;
        style.bottom = 0;
      }
      if (cp && pindex === 2) {
        style.top = 0;
        style.right = 0;
      }
      if (cp && pindex === 3) {
        style.top = 0;
        style.left = 0;
      }
      return style;
    },
    login() {
      this.$api.autoLogin().then(res => {
        localStorage.setItem('mapconfigdata', res);
      });
    },
    // 更新地图
    updateMap(val) {
      this.mpcAlldata = val;
      console.log(this.mpcAlldata);
      if (val.item) this.currentformuser = val.item;
      Object.keys(val.form).map(item => {
        if (val.form[item].fileUrl) val.form[item] = val.form[item].fileUrl;
        return item;
      });
      this.mpcdata = val.form;
      this.modeltype = val.form.modeltype.replace('模板', '');
      Object.keys(this.mtObj).forEach(elem => {
        if (this.mpcdata[elem]) this.mtObj[elem] = this.mpcdata[elem];
      });
      let typeform = '';
      console.log(val.jsonOption);
      if (val.jsonOption) {
        this.jsonOption = val.jsonOption;
        if (val.jsonOption.type) {
          typeform = val.jsonOption.type;
          this.typemodel = val.jsonOption.type.model.replace('模板', '');
          if (val.jsonOption.type.typeflag === '否') this.typeshow = false;
          // console.log(this.typeshow)
        }
      }
      this.getType(typeform);
      this.map = null;
      let mapcontent = document.querySelector('#map');
      if (mapcontent.childNodes.length > 0) {
        mapcontent.removeChild(mapcontent.childNodes[0]);
      }
      this.$nextTick(() => {
        this.mpcdata.mapmodetype === '切片地图' ? this.Tilemap(this.mpcdata) : this.staticmap(this.mpcdata);
        if (!val.update) this.getData(Math.round(this.map.getView().getZoom()));
      });
    },
    Tilemap(val) {
      this.mapconfig.mapMinZoom = Number(val.map_min_level);
      this.mapconfig.mapMaxZoom = Number(val.map_max_level);
      this.mapconfig.currentZoom = this.isPc ? Number(val.current_level) : Number(val.app_current_level);
      this.mapconfig.extent = val.transform_extent.split(',');
      this.mapconfig.extent.forEach((item, index) => {
        this.mapconfig.extent[index] = Number(this.mapconfig.extent[index]);
      });
      this.mapconfig.center = this.isPc ? val.map_center.split(',') : val.app_map_center.split(',');
      this.mapconfig.center.forEach((item, index) => {
        this.mapconfig.center[index] = Number(this.mapconfig.center[index]);
      });
      const mapExtent = transformExtent(this.mapconfig.extent, 'EPSG:4326', 'EPSG:3857');
      this.drawsource = new VectorSource();
      this.drawLayer = new VectorLayer({
        source: this.drawsource,
        style: this.styleFunction
      });
      this.iconSource = new VectorSource();
      this.iconLayer = new VectorLayer({
        source: this.iconSource
      });
      this.wmsLayer = new TileLayer({
        extent: mapExtent,
        source: new XYZ({
          attributions: [new Attribution({
            html: '1; Rendered with <a href="https://www.maptiler.com/">MapTiler Desktop</a>'
          })],
          url: 'tiles/' + this.$route.query.formUserId + '/{z}/{x}/{y}.png',
          tilePixelRatio: 1.000000,
          minZoom: this.mapconfig.mapMinZoom,
          maxZoom: this.mapconfig.mapMaxZoom
        })
      });
      this.map = new Map({
        controls: defaults({
          attribution: false
        }),
        target: this.$refs.maps,
        layers: [this.wmsLayer, this.iconLayer, this.drawLayer],
        logo: false,
        view: new View({
          center: fromLonLat(this.mapconfig.center),
          zoom: this.mapconfig.currentZoom,
          minZoom: this.mapconfig.mapMinZoom,
          maxZoom: this.mapconfig.mapMaxZoom
        })
      });
      this.mapLoadEnd();
    },
    // 静态地图
    staticmap(val) {
      // console.log(val)
      this.mapconfig.mapMinZoom = val.static_map_min_level ? Number(val.static_map_min_level) : 1;
      this.mapconfig.mapMaxZoom = val.static_map_max_level ? Number(val.static_map_max_level) : 2;
      this.mapconfig.currentZoom = this.isPc ? Number(val.current_level) : Number(val.app_current_level);
      this.mapconfig.center = this.isPc ? val.map_center.split(',') : val.app_map_center.split(',');
      this.mapconfig.center.forEach((item, index) => {
        this.mapconfig.center[index] = Number(this.mapconfig.center[index]);
      });
      let extent = val.transform_extent ? val.transform_extent.split(',') : [0, 0, 480, 480];
      let projection = new Projection({
        projection: 'EPSG:4326',
        code: 'xkcd-image',
        units: 'pixels',
        extent: extent
      });
      this.imageLayer = new LayerImage({
        source: new SourceImagestatic({
          url: val.static_img,
          //这里添加静态图片的地址
          projection: projection,
          imageExtent: extent
        })
      });
      this.iconSource = new VectorSource();
      this.iconLayer = new VectorLayer({
        source: this.iconSource
      });
      this.drawsource = new VectorSource();
      this.drawLayer = new VectorLayer({
        source: this.drawsource,
        style: this.styleFunction
      });
      this.map = new Map({
        controls: defaults({
          attribution: false
        }),
        layers: [this.imageLayer, this.iconLayer, this.drawLayer],
        target: this.$refs.maps,
        view: new View({
          projection: projection,
          center: this.mapconfig.center,
          zoom: this.mapconfig.currentZoom,
          minZoom: this.mapconfig.mapMinZoom,
          maxZoom: this.mapconfig.mapMaxZoom
        })
      });
      this.mapLoadEnd();
      // this.map.getView().on('change:resolution', this.resolutionchange)
    },
    // 加载地图后 处理事件
    mapLoadEnd() {
      this.map.on('singleclick', this.singleclick);
      this.map.on('click', this.markerclick);
      this.map.on('pointermove', this.markermove);
      if (this.mpcdata.dragazoom && this.mpcdata.dragazoom === '是') getPan(this.map);
      if (this.mpcdata.dragrotate && this.mpcdata.dragrotate === '是') getPinchRotate(this.map);
      let that = this;
      // 缩放地图 结束后事件
      this.mapdataform.deptId = this.fid;
      this.searchStr.filters.forEach(item => {
        if (item.filters.length > 0) {
          item.filters.forEach(child => {
            if (child.alias === '40') child.val = this.mpcdata['46'] || this.mpcdata['title'];
          });
        }
      });
      this.mapdataform.searchStr = encodeURI(JSON.stringify(this.searchStr));
      this.map.on('moveend', function (event) {
        let zoom = Math.round(event.map.getView().getZoom());
        if (that.zoom === zoom) return;
        that.zoom = zoom;
        let minZoom = that.mapconfig.mapMinZoom;
        console.log(minZoom);
        let orData = [];
        for (let i = minZoom; i <= zoom; i++) {
          orData.push({
            'alias': 'map_level',
            'compt': 'editinput',
            'express': '===',
            'val': i
          });
        }
        that.searchStr.filters.forEach(item => {
          if (item.model === 1) item.filters = orData;
        });
        that.mapdataform.searchStr = encodeURI(JSON.stringify(that.searchStr));
        that.iconSource.clear();
        that.mapdataform.page = 1;
        that.getData();
      });
      // 绘画字段初始化
      if (this.jsonOption.draw) {
        let style = this.jsonOption.drawstyle;
        let drawObj = JSON.parse(this.jsonOption.draw);
        const splitfeature = new GeoJSON().readFeatures(this.jsonOption.draw);
        splitfeature.forEach((elem, index) => {
          elem.setStyle(new Style({
            stroke: new StyleStroke({
              color: style[index].color,
              width: style[index].size / 2,
              lineDash: style[index].lineDash
            })
          }));
          this.drawsource.addFeature(elem);
        });
      }
    },
    // PC端指针移动时触发 移动端平移地图时触发
    markermove(evt) {
      let allfeatures = this.iconSource.getFeatures();
      allfeatures.forEach(item => {
        if (item.get('hover')) {
          this.iconSource.removeFeature(item);
        }
      });
      let feature = this.map.forEachFeatureAtPixel(evt.pixel, function (feature) {
        return feature;
      });
      if (feature) {
        let featureName = feature.get('name');
        let featureCenter = feature.get('xy');
        let featureId = feature.get('id');
        let featureImage = feature.get('image');
        let picwidth = feature.get('picwidth');
        this.hoverId = featureId;
        if (!featureCenter) return;
        if (this.mpcdata.location_title === '2') {
          const yvalue = 0.0006 / (this.zoom * (this.zoom + 1));
          let x = featureCenter[0];
          let y = featureCenter[1] + yvalue;
          let textFeature = new Feature({
            geometry: new Point(fromLonLat([x, y])),
            id: `hover${featureId}`,
            name: featureName,
            hover: true
          });
          let stroke = this.mtObj.title_bocolor;
          textFeature.setStyle(new Style({
            text: new StyleText({
              text: featureName,
              font: this.mtObj.title_font,
              fill: new StyleFill({
                // 可以在此处设置字体样式，与css同
                color: this.mtObj.title_color
              }),
              offsetX: this.mtObj.offsetX,
              offsetY: 0,
              backgroundFill: new StyleFill({
                color: this.mtObj.title_bgcolor
              }),
              stroke: stroke !== '' ? new StyleStroke({
                color: stroke,
                width: 2
              }) : '',
              padding: this.mtObj.padding
            })
          }));
          this.iconSource.addFeature(textFeature);
        }
        if (this.mpcdata.pointImg === '2') {
          if (!featureImage) return;
          const yvalue = 0.0015 / (this.zoom * (this.zoom + 1));
          let x = featureCenter[0];
          let y = featureCenter[1] + yvalue;
          let imgFeature = new Feature({
            geometry: new Point(fromLonLat([x, y])),
            id: `hover${featureId}`,
            name: featureName,
            hover: true
          });
          imgFeature.setStyle(new Style({
            image: new StyleIcon({
              src: featureImage,
              width: 50
            })
          }));
          let that = this;
          let imgstyle = imgFeature.getStyle();
          let img = new Image();
          img.src = imgstyle.image_.iconImage_.src_;
          img.onload = function () {
            let width = img.width;
            // 以宽度为100为例
            let imgmultiple = !that.isPc ? that.mpcdata.appimgW / width : (picwidth !== undefined && picwidth.length !== 0 ? parseInt(picwidth) : that.mpcdata.dotimgW) / width;
            imgstyle.getImage().setScale(imgmultiple);
            imgFeature.setStyle(imgstyle);
            // console.log(that)
            that.iconSource.addFeature(imgFeature);
          };
        }
      }
    },
    // 移动显示标题
    markerclick(evt) {
      let feature = this.map.forEachFeatureAtPixel(evt.pixel, function (feature) {
        return feature;
      });
      if (feature) {
        let featureName = feature.get('name');
        if (featureName !== undefined) alert(featureName);
      }
    },
    // 获取当前 地图位置
    singleclick(val) {
      let coordinateArr = transform(val.coordinate, 'EPSG:3857', 'EPSG:4326');
      let coordinate = coordinateArr[0].toFixed(6) + "," + coordinateArr[1].toFixed(6);
      console.log("coordinate: " + coordinateArr[0].toFixed(6) + "," + coordinateArr[1].toFixed(6));
      localStorage.setItem('coordinate', coordinate);
      // this.dataform.map_coordinates = coordinate
      this.$refs.pointComp.getCoordinate();
    },
    // 获取分类结构数据
    getTypeStruct() {
      let params = {
        deptId: this.$route.query.fid,
        formId: 260297
      };
      this.$api.formStruct(params).then(res => {
        this.typestruct = res.map(item => {
          let itemObj = {
            alias: item.alias,
            compt: item.compt,
            values: [{
              val: ''
            }]
          };
          return itemObj;
        });
        // console.log(this.typestruct)
      });
    },
    // 获取分类数据
    getType(val) {
      let typeform = {
        deptId: this.$route.query.fid,
        formId: '260297',
        limit: 50,
        orderBy: val && val !== '' && val.orderBy !== '' ? val.orderBy : 'manualOrderTop,manualOrder',
        orderType: val && val !== '' && val.orderType !== '' ? val.orderType : '',
        searchStr: ''
      };
      this.$api.singleadvanceSearch(typeform).then(res => {
        if (res.totalRow > 0) {
          this.typeArr = [];
          let formatDataList = res.dataList.map(item => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[transformStr3(itemformdata[key].alias)] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
            this.typeArr.push({
              value: item.itemformdata.title,
              formUserId: item.id,
              formId: item.formId,
              disabled: true,
              id: item.itemformdata[2],
              icon: itemformat.icon && itemformat.icon.length > 0 ? itemformat.icon[0].fileUrl : ''
            });
            return item;
          });
          // console.log(this.typeArr)
          // console.log(formatDataList)
        } else {
          this.typeArr.push({
            value: ''
          });
        }
      });
    },
    // 失焦后添加
    blurInput(val, index) {
      if (this.typeArr && this.typeArr[0].value) this.typeFlag = true;
      let formData = {
        deptId: this.$route.query.fid,
        formId: 260297,
        uid: 145444302
      };
      let addData = JSON.parse(JSON.stringify(this.typestruct));
      // console.log(this.mpcdata)
      addData = addData.map(item => {
        if (item.alias === 'title') item.values[0].val = this.typeArr[index].value;
        if (item.alias === '3') item.values[0].val = this.mpcdata.title;
        if (item.alias === 'onlyid') item.values[0].val = this.mpcdata.onlyid;
        return item;
      });
      this.$api.addFormdata(formData, encodeURI(JSON.stringify(addData))).then(res => {
        // console.log(res)
        ElNotification({
          message: '添加成功',
          type: 'success'
        });
        let _this = this;
        setTimeout(() => {
          _this.getType(_this.jsonOption.type);
        }, 1500);
      });
    },
    // 添加分类操作
    addType() {
      this.typeArr.push({
        value: ''
      });
    },
    // 删除分类操作
    deleteType(index) {
      if (this.typeArr.length !== 1) {
        ElMessageBox.confirm('确定要删除么？', '温馨提示', {
          distinguishCancelAndClose: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          if (this.typeArr[index].value === '') {
            this.typeArr.splice(index, 1);
          } else {
            let deleteform = {
              formId: this.typeArr[index].formId,
              formUserId: this.typeArr[index].formUserId
            };
            this.$api.deleteFormdata(deleteform).then(res => {
              ElNotification({
                message: '删除成功',
                type: 'success'
              });
              let _this = this;
              setTimeout(() => {
                _this.getType(_this.jsonOption.type);
              }, 1500);
            });
          }
        }).catch(() => {});
        // this.typeArr.splice(index, 1)
      }
    },
    typeselect() {},
    // 添加地图管理配置
    addconfigMapData() {
      let formData = {
        deptId: this.$route.query.fid,
        formId: 177623,
        uid: 145444302
      };
      let mapcenterX = this.form.map_centerX ? parseInt(this.form.map_centerX) : 240;
      let mapcenterY = this.form.map_centerY ? parseInt(this.form.map_centerY) : 240;
      let addData = JSON.parse(JSON.stringify(this.mapconfigstruct));
      addData = addData.map(item => {
        if (item.alias === 'title') item.values[0].val = this.form.title;
        if (item.alias === 'toptitle') item.values[0].val = this.form.toptitle;
        if (item.alias === 'logo') {
          let picObj = this.fileArr.find(elem => elem.name === 'logo');
          if (!picObj) return;
          item.values = this.imagefilevideoHandle(formData.uid, picObj.data);
        }
        if (item.alias === 'pickey') {
          let picObj = this.fileArr.find(elem => elem.name === 'pickey');
          if (!picObj) return;
          item.values = this.imagefilevideoHandle(formData.uid, picObj.data);
        }
        if (item.alias === 'background_img') {
          let picObj = this.fileArr.find(elem => elem.name === 'background_img');
          if (!picObj) return;
          item.values = this.imagefilevideoHandle(formData.uid, picObj.data);
        }
        if (item.alias === 'static_img') {
          let picObj = this.fileArr.find(elem => elem.name === 'static_img');
          if (!picObj) return;
          item.values = this.imagefilevideoHandle(formData.uid, picObj.data);
        }
        if (item.alias === 'mapmodetype') item.values[0].val = '静态地图';
        if (item.alias === 'static_map_min_level') item.values[0].val = this.mpcdata.static_map_min_level;
        if (item.alias === 'static_map_max_level') item.values[0].val = this.mpcdata.static_map_max_level;
        if (item.alias === 'current_level') item.values[0].val = this.mpcdata.current_level;
        if (item.alias === 'map_center') item.values[0].val = mapcenterX + ',' + mapcenterY;
        if (item.alias === 'transform_extent') item.values[0].val = '0,0,480,480';
        return item;
      });
      // console.log(addData)
      this.$api.addFormdata(formData, encodeURI(JSON.stringify(addData))).then(res => {
        // console.log(res)
        if (res) {
          this.isAddOrEdit = false;
        }
      });
      this.typeFlag = true;
    },
    // 地点添加数据操作
    addDataHandle() {
      this.detailflag = true;
      this.isAddDataflag = true;
      this.currentLiIndex = '';
      this.$refs.pointComp.init();
    },
    prevHandle() {
      this.stepIndex--;
    },
    // 获取地点数据  未做分页
    getData() {
      let that = this;
      this.$api.singleadvanceSearch(this.mapdataform).then(res => {
        if (res.totalRow > 0) {
          // 格式化数据
          if (res.totalPage === 1) {
            that.dataList = [];
            that.iconSource.clear();
            that.dataformat(res);
          } else {
            if (that.mapdataform.page === 1) {
              that.dataList = [];
              that.iconSource.clear();
              that.dataformat(res);
            } else {
              that.dataformat(res);
            }
            that.mapdataform.page++;
            if (res.totalPage >= that.mapdataform.page) that.getData();
          }
          // 珠海处理数据 定制化需求
          if (this.fid === '216022') {
            let dataList = this.dataList.filter(item => {
              return item.itemformdata['42'] !== '仅展示';
            });
            this.zhDataform(dataList);
          }
        }
      });
    },
    dataformat(res) {
      res.dataList.forEach((item, index) => {
        let itemformdata = item.formIdValueData;
        let itemformat = {};
        Object.keys(itemformdata).forEach(key => {
          itemformat[transformStr3(itemformdata[key].alias)] = getformListItemsdatas(itemformdata[key]);
        });
        if (itemformat.mapType.length === 0) itemformat.mapType = '';
        item.itemformdata = itemformat;
        this.createPoint(itemformat, item);
      });
      if (this.mapdataform.page === 1) {
        this.dataList = res.dataList;
        // this.dataList = res.dataList.filter(item => { return item.itemformdata['42'] !== '仅展示' })
      } else {
        this.dataList.concat(res.dataList);
        // this.dataList.concat(res.dataList.filter(item => { return item.itemformdata['42'] !== '仅展示' }))
      }
    },
    createPoint(itemformat, item) {
      let _this = this;
      if (!itemformat.mapCoordinates) return;
      let c = itemformat.mapCoordinates.split(',');
      let cX = Number(c[0]);
      let cY = Number(c[1]);
      let imgtextFeature = new Feature({
        geometry: new Point(fromLonLat([cX, cY])),
        id: item.id,
        name: itemformat.placeName,
        xy: [cX, cY]
      });
      let textstyle = '';
      if (this.mpcdata.location_title === '显示' || itemformat.showplaceName === '是') {
        if (itemformat.titleoffset !== undefined && itemformat.titleoffset.length !== 0 && !itemformat.titleoffset.includes('NaN')) {
          let to = itemformat.titleoffset.split(',');
          // console.log(to)
          this.mtObj.offsetX = parseInt(to[0]);
          this.mtObj.offsetY = parseInt(to[1]);
        }
        let stroke = this.mtObj.title_bocolor;
        let placename = itemformat.placeName;
        if (placename.length > 10) {
          placename = insertStr(placename, 10, ',');
        }
        textstyle = new StyleText({
          text: placename.includes(',') ? placename.split(',').join('\n') : placename,
          font: this.mtObj.title_font,
          fill: new StyleFill({
            // 可以在此处设置字体样式，与css同
            color: this.mtObj.title_color
          }),
          offsetX: this.mtObj.offsetX,
          offsetY: itemformat.show4 === '否' ? 0 : this.mtObj.offsetY,
          backgroundFill: new StyleFill({
            color: this.mtObj.title_bgcolor
          }),
          stroke: stroke !== '' ? new StyleStroke({
            color: stroke,
            width: 2
          }) : '',
          padding: this.mtObj.padding
        });
      }
      if (this.mpcdata.location_title !== '是') textstyle = '';
      // show4 点位中图片是否显示字段
      let imageicon = itemformat[4].length === 0 ? '' : this.mpcdata.pointImg === '是' ? new StyleIcon({
        radius: 4,
        src: handleHttp(itemformat[4][0].fileUrl),
        offset: [0, 0],
        width: 100
      }) : '';
      imgtextFeature.setStyle(new Style({
        image: itemformat.show4 === '否' ? '' : imageicon,
        text: itemformat.showplaceName === '否' ? '' : textstyle
      }));

      // 处理图片宽度自适应地图
      if (itemformat.show4 !== '否' && imageicon !== '') {
        let iconstyle = imgtextFeature.getStyle();
        let img = new Image();
        img.src = iconstyle.image_.iconImage_.src_;
        img.onload = function () {
          let width = img.width;
          // 以宽度为100为例
          let imgmultiple = !_this.isPc ? _this.mpcdata.appimgW / width : (itemformat.picwidth !== undefined && itemformat.picwidth.length !== 0 ? parseInt(itemformat.picwidth) : _this.mpcdata.dotimgW) / width;
          iconstyle.getImage().setScale(imgmultiple);
          imgtextFeature.setStyle(iconstyle);
          // console.log(_this)
          _this.iconSource.addFeature(imgtextFeature);
        };
      } else {
        this.iconSource.addFeature(imgtextFeature);
      }
      if (this.mpcdata.pointIcon === '是') {
        let iconFeature = new Feature({
          geometry: new Point(fromLonLat([cX, cY])),
          id: `icon${item.id}`,
          name: itemformat.placeName,
          xy: [cX, cY],
          image: itemformat[4].length === 0 ? '' : handleHttp(itemformat[4][0].fileUrl),
          picwidth: itemformat.picwidth
        });
        let icon = itemformat.mapType === '' ? this.defaultIcon : this.getTypeIcon(itemformat['43']);
        if (icon !== '') {
          iconFeature.setStyle(new Style({
            image: new StyleIcon({
              radius: 4,
              src: icon,
              offset: [0, 0],
              width: 28
            })
          }));
          this.iconSource.addFeature(iconFeature);
        }
      }
    },
    getTypeIcon(id) {
      let icon = this.defaultIcon;
      this.typeArr.forEach(elem => {
        if (Number(elem.id) === Number(id)) {
          if (elem.icon && elem.icon !== '') icon = elem.icon;
        }
      });
      return icon;
    },
    // 地点列表点击操作
    dataliHandle(item, index) {
      // console.log(item)
      // console.log(index)
      this.currentLiIndex = index;
      // console.log(this.map)
      // let view = this.map.getView()
      // let zoom = item.itemformdata.mapLevel
      // view.setZoom(zoom)
      this.detailflag = true;
      this.isAddDataflag = false;
      this.detailObj = item;
      this.iconSource.clear();
      this.createPoint(item.itemformdata, item);
      this.$refs.pointComp.init();
    },
    gobacktype() {
      this.detailflag = false;
      this.isAddDataflag = true;
      this.iconSource.clear();
      let view = this.map.getView();
      let zoom = this.mpcAlldata.form.current_level;
      view.setZoom(zoom);
      this.getData();
    },
    successHandle() {
      let _this = this;
      this.detailflag = false;
      setTimeout(() => {
        _this.iconSource.clear();
        let view = _this.map.getView();
        let zoom = _this.mpcAlldata.form.current_level;
        view.setZoom(zoom);
        _this.getData();
      }, 1500);
    },
    getdatalevel(val) {
      this.leveloptions = val;
      this.dataleveloption = val.filter(item => {
        return String(item.title).indexOf('.') === -1;
      });
    },
    aoeStatus(val) {
      this.isAddOrEdit = val;
    },
    // 导航跳转操作
    navHandle(index) {
      // console.log(this.mpcdata)
      if (this.isAddOrEdit) {
        ElMessage({
          message: '请先配置地图数据',
          type: 'warning'
        });
        return;
      }
      this.stepIndex = index;
      this.detailflag = false;
      if (index === 2) {
        this.$refs.pointComp.getDatastruct();
      }
    },
    // 保存操作
    saveHandle() {
      // console.log(this.mpcdata)
      // delete this.jsonOption.typenav
      const data = JSON.stringify(this.jsonOption);
      let editData = [];
      editData.push({
        'alias': 'title',
        'compt': 'editinput',
        'values': [{
          'val': this.mpcdata.title
        }]
      });
      editData.push({
        'alias': 'toptitle',
        'compt': 'editinput',
        'values': [{
          'val': this.mpcdata.toptitle
        }]
      });
      editData.push({
        'alias': 'jsontxt',
        'compt': 'richtext',
        'values': [{
          'val': '<p element-id=\"init\" style="display: none;">' + data + '</p>'
        }]
      });
      this.$api.editForm(this.$route.query.fid, this.$route.query.formUserId, encodeURI(JSON.stringify(editData)), this.currentformuser.formId).then(res => {
        ElMessage({
          message: '更新成功',
          type: 'success'
        });
      });
    },
    // 发布操作
    releaseHandle() {
      let href = location.href.replace('mapconfig', 'superMap');
      window.open(href);
    },
    // 表单无数据返回空
    getformdata(data) {
      let typekey = 'val';
      if (!data.values) return '';
      if (!data.values[0]) return '';
      let valuesdata = data.values[0];
      if (data.compt === 'imagebox') return valuesdata;
      return valuesdata[typekey] !== '' ? valuesdata[typekey] : '';
    },
    switchRight() {
      this.showRightslide = !this.showRightslide;
      this.zoom = 0;
      this.updateMap(this.mpcAlldata);
    },
    // 切换屏幕事件
    screenswitch(index) {
      this.isPc = index === 0 ? true : false;
      this.screenIndex = index;
      this.zoom = 0;
      this.updateMap(this.mpcAlldata);
      // 0：PC   1：移动
      if (index === 1) {}
    },
    // 增加主体分辨率
    plusScale() {
      if (this.screenvalue < 150) {
        this.screenvalue += 10;
        let maininnerbox = document.querySelector('.maininnerbox');
        let scale = this.screenvalue / 100;
        this.maininnerStyle = {
          width: 1920 * scale + 'px',
          height: 1080 * scale + 'px'
        };
        this.zoom = 0;
        this.updateMap(this.mpcAlldata);
      }
    },
    // 减少主体分辨率
    minusScale() {
      if (this.screenvalue > 0) {
        this.screenvalue -= 10;
        let maininnerbox = document.querySelector('.maininnerbox');
        let scale = this.screenvalue / 100;
        this.maininnerStyle = {
          width: 1920 * scale + 'px',
          height: 1080 * scale + 'px'
        };
        this.zoom = 0;
        this.updateMap(this.mpcAlldata);
      }
    },
    screenmousedown(event) {
      // console.log(event)
      // let e = window.event || event
      // e.preventDefault()
      // let startX = e.pageX
      // let startY = e.pageY
      // document.onmousemove = e => {
      //   endX = e.pageX
      //   endY = e.pageY
      // }
      // document.onmouseup = e => {
      //   document.onmousemove = null
      //   document.onmouseup = null
      // }
    },
    leftUlClick(item, index) {
      this.leftUlIndex = index;
    },
    typeUlclick(val) {
      this.typeUlIndex = val;
      // console.log(this.styleform)
      if (val === 0) {
        let normal = this.styleform.othernormalform;
        if (normal) {
          Object.keys(normal).forEach(elem => {
            if (elem === 'height') this.otherform.height = normal[elem] === undefined ? 40 : normal[elem];
            if (elem !== 'height') this.otherform[elem] = normal[elem];
          });
        } else {
          Object.keys(this.otherform).forEach(elem => {
            this.otherform[elem] = '';
          });
        }
        // this.styleform.othernormalform = this.otherform
      }
      if (val === 1) {
        let focus = this.styleform.otherfocusform;
        if (focus) {
          Object.keys(focus).forEach(elem => {
            if (elem === 'height') this.otherform.height = focus[elem] === undefined ? 40 : focus[elem];
            if (elem !== 'height') this.otherform[elem] = focus[elem];
          });
        } else {
          // console.log(this.otherform)
          Object.keys(this.otherform).forEach(elem => {
            this.otherform[elem] = elem === 'backgroundfile' ? [] : '';
          });
        }
        // this.styleform.otherfocusform = this.otherform
      }
    },
    uploadClick() {},
    beforeAvatarUpload(rawFile) {
      if (rawFile.type !== 'image/jpeg') {
        ElMessage.error('Avatar picture must be JPG format!');
        return false;
      } else if (rawFile.size / 1024 / 1024 > 2) {
        ElMessage.error('Avatar picture size can not exceed 2MB!');
        return false;
      }
      return true;
    },
    // 上传文件
    uploadChange(rawFile) {
      let formData = new FormData();
      formData.append('file', rawFile.raw);
      formData.append('_uid', this.$route.query.uid);
      formData.append('fid', this.$route.query.fid);
      this.$api.uploadSingle(formData).then(res => {
        res.url = handleHttp(res.http);
        this.otherform.backgroundImage = 'url(\'' + res.http + '\')';
        // console.log(this.otherform)
        // console.log(this.otherform.backgroundfile)
        this.othercsshandleChange('backgroundImage');
        // this.otherform.backgroundfile = [
        //   {url: res.url, name: res.name}
        // ]
      });
    },
    // 删除图片文件操作
    handleRemove(file, name) {
      // console.log(file)
      this.otherform.backgroundImage = '';
      this.otherform.backgroundfile = [];
    },
    styleFunction(feature) {
      const styles = [
      // linestring
      new Style({
        stroke: new StyleStroke({
          color: '#877d6a',
          width: 1,
          lineDash: [4, 2]
        })
      })];
      return styles;
    },
    // 添加线段
    addInteraction(type) {
      this.linefoucs = true;
      const fill = new StyleFill({
        color: '#2663FF'
      });
      const stroke = new StyleStroke({
        color: '#ffffff',
        width: 2
      });
      let textDesc = '点击开始绘制';
      this.draw = new Draw({
        source: this.drawsource,
        type: type
        // style: new Style({
        //   fill: fill,
        //   stroke: new StyleStroke({
        //     color: '#2663FF',
        //     width: 2
        //   }),
        //   image: new Circle({
        //     fill: fill,
        //     radius: 6,
        //     stroke: stroke
        //   }),
        //   text: new StyleText({
        //     text: textDesc,
        //     font: 'bold 12px 微软雅黑',
        //     fill: new StyleFill({color: '#fff'}),
        //     offsetX: 12,
        //     textAlign: 'left',
        //     backgroundFill: new StyleFill({
        //       color: 'rgba(0,0,0,0.1)'
        //     }),
        //     padding: [4,4,2,4]
        //   })
        // })
      });
      this.collection = new Collection();
      this.modify = new Modify({
        //集合里的要素是动态添加修改的，只需要放一次就好
        features: this.collection
      });
      //添加一个选择器
      this.map.addInteraction(this.modify);
      let _this = this;
      this.draw.on('drawstart', e => {
        console.log(`绘制开始`);
        console.log(e.feature);
        console.log(e.feature.getGeometry().getType());
        textDesc = '双击绘制结束';
        console.log(this.draw);
      });
      this.draw.on('drawend', e => {
        console.log(`绘制结束`);
        console.log(e);
        console.log(e.feature);
        this.draw.setActive(false);
        this.collection.push(e.feature);
        this.dialogVisible = true;
        // this.drawsource.addFeature(e.feature)
      });
      this.map.addInteraction(this.draw);
    },
    // 保存绘制数据
    saveDraw() {
      this.linefoucs = false;
      this.dialogVisible = false;
      let feature = this.drawsource.getFeatures();
      console.log(feature);
      let jsonObj = new GeoJSON().writeFeatures(feature);
      const importObject = new GeoJSON().readFeatures(jsonObj);
      this.jsonOption.draw = jsonObj;
      console.log("->GeoJson格式数据：", jsonObj);
      console.log(importObject);
      // ElMessage({message: '绘制数据保存成功', type: 'success'})
      this.map.removeInteraction(this.modify);
      this.drawstyle.push({
        color: this.lineform.color,
        width: this.lineform.size / 2,
        lineDash: this.lineform.borderstyle
      });
      this.jsonOption.drawstyle = this.drawstyle;
      console.log(this.jsonOption);
    },
    // 取消绘制数据
    drawQuit() {
      let features = this.drawsource.getFeatures();
      let current = features[features.length - 1];
      this.drawLayer.getSource().removeFeature(current);
      this.drawstyle[this.drawstyle.length - 1];
      this.saveDraw();
    },
    // 清除绘制数据
    clearDraw() {
      ElMessageBox.confirm('确定要全部清除绘制数据么', '温馨提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.drawsource.clear();
        this.jsonOption.draw = '';
      }).catch(() => {});
    },
    // 珠海处理数据
    zhDataform(data) {
      let dataList = JSON.parse(JSON.stringify(data));
      let zhdataList = [];
      let zhdata = [];
      let pcaArr = [{
        title: '44,4404,440403|广东省,珠海市,斗门区',
        status: 0
      }, {
        title: '44,4404,440408|广东省,珠海市,鹤洲新区',
        status: 0
      }, {
        title: '44,4404,440406|广东省,珠海市,高新区',
        status: 1
      }, {
        title: '44,4404,440402|广东省,珠海市,香洲区',
        status: 1
      }, {
        title: '44,4404,440404|广东省,珠海市,金湾区',
        status: 2
      }, {
        title: '44,4404,440407|广东省,珠海市,横琴粤澳深度合作区',
        status: 2
      }];
      pcaArr.forEach((elem, index) => {
        let elemdata = dataList.filter(item => {
          return item.itemformdata.pca === elem.title;
        });
        zhdata.push(elemdata);
      });
      zhdataList = [].concat.apply([], zhdata);
      zhdataList.forEach((elem, index) => {
        pcaArr.forEach(aitem => {
          if (aitem.title === elem.itemformdata.pca) {
            elem.itemformdata.status = aitem.status;
          }
        });
        this.createPointTitle(elem.itemformdata, index);
      });
    },
    // 创建绘制文字 0.000175,0.003755
    createPointTitle(item, index) {
      if (item && item['42'] !== '仅展示') {
        // 0.002245,0.002812
        // 0.001235,0.001576
        let titlecolor = '';
        let _this = this;
        let cX = '';
        let cY = '';
        let name = '';
        let textBaseline = 'top';
        if (item.status === 2) {
          cX = Number(0.000785 + (index - 36) * 0.00005);
          cY = Number(0.001576);
          item.placeName = item.placeName.replace(/\uff08/g, '\ufe35');
          item.placeName = item.placeName.replace(/\uff09/g, '\ufe36');
          name = item.placeName.split('').join('\n');
          titlecolor = (index - 2) % 4 === 0 ? '#172d59' : '#475538';
        } else if (item.status === 1) {
          cX = Number(0.002075);
          cY = Number(0.003180 - (index - 20) * 0.00006);
          name = item.placeName;
          if ((index - 20) % 3 === 0) titlecolor = '#482618';
          if ((index - 21) % 3 === 0) titlecolor = '#172d59';
          if ((index - 22) % 3 === 0) titlecolor = '#475538';
          textBaseline = 'left';
        } else {
          cX = Number(0.000165 + index * 0.00005);
          cY = Number(0.003439);
          item.placeName = item.placeName.replace(/\uff08/g, '\ufe35');
          item.placeName = item.placeName.replace(/\uff09/g, '\ufe36');
          name = item.placeName.split('').join('\n');
          titlecolor = (index - 1) % 3 === 0 ? '#482618' : '#475538';
        }
        let iconFeature = new Feature({
          geometry: new Point(fromLonLat([cX, cY])),
          id: `${index}`,
          name: item.placeName
        });
        iconFeature.setStyle(new Style({
          text: new StyleText({
            text: name,
            textBaseline: textBaseline,
            textAlign: 'left',
            font: 'normal 12px 宋体',
            fill: new StyleFill({
              color: titlecolor
            })
          })
        }));
        this.iconSource.addFeature(iconFeature);
      }
    },
    // 改变绘制线样式
    drawLineChange(e) {
      let borderstyle = [];
      switch (this.lineform.style) {
        case 1:
          borderstyle = [];
          break;
        case 2:
          borderstyle = [2, 2, 4];
          break;
        case 3:
          borderstyle = [4, 2];
          break;
        case 4:
          borderstyle = [2, 2];
          break;
        default:
          break;
      }
      this.lineform.borderstyle = borderstyle;
      this.collection.getArray()[0].setStyle(new Style({
        stroke: new StyleStroke({
          color: this.lineform.color,
          // 边框颜色
          width: this.lineform.size / 2,
          // 边框宽度
          lineDash: borderstyle
        })
      }));
    }
  }
};